var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIcoThumbsUpGreen(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.62093 30.9998H4.04837C3.23989 30.9998 2.46453 30.6837 1.89285 30.1211C1.32117 29.5585 1 28.7955 1 27.9998V17.4999C1 16.7043 1.32117 15.9412 1.89285 15.3786C2.46453 14.816 3.23989 14.4999 4.04837 14.4999H8.62093M19.2902 11.4999V5.49997C19.2902 4.3065 18.8085 3.16192 17.951 2.31801C17.0934 1.4741 15.9304 1 14.7177 1L8.62093 14.4999V30.9998H25.8137C26.5489 31.008 27.2623 30.7544 27.8225 30.2858C28.3826 29.8172 28.7519 29.1652 28.8621 28.4498L30.9655 14.9499C31.0318 14.5199 31.0023 14.0809 30.8791 13.6633C30.7559 13.2457 30.5419 12.8594 30.2519 12.5312C29.962 12.203 29.603 11.9408 29.1998 11.7628C28.7967 11.5847 28.359 11.495 27.9171 11.4999H19.2902Z",
    stroke: "#33D085",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoThumbsUpGreen);
export default __webpack_public_path__ + "static/media/ico_thumbs_up_green.6527d80f904541e0ed8a1bc58504a182.svg";
export { ForwardRef as ReactComponent };